import { index, jsonb, pgTable, text, timestamp, uniqueIndex, uuid } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
import { organisationIntegrations } from "./integrations";
/**
 * Cached database schema metadata per organization (generic for all database types).
 * Stores table/column information, relationships, and query counts.
 */
export const databaseSchemaCache = pgTable("database_schema_cache", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    integrationId: uuid("integration_id")
        .notNull()
        .references(() => organisationIntegrations.id, { onDelete: "cascade" }),
    databaseType: text("database_type").notNull().$type(),
    schemaJson: jsonb("schema_json").notNull().$type(),
    queryCountsJson: jsonb("query_counts_json").notNull().$type().default({}),
    refreshedAt: timestamp("refreshed_at", { withTimezone: true }).notNull().defaultNow(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    uniqueCompanyIntegration: uniqueIndex("database_schema_cache_company_integration").on(table.companyId, table.integrationId),
    companyIdx: index("database_schema_cache_company").on(table.companyId),
    databaseTypeIdx: index("database_schema_cache_database_type").on(table.databaseType),
}));
/**
 * Semantic anchors for database integrations (Postgres, MySQL, MongoDB, etc.).
 * Stores lightweight mappings like primary user table/collection, signup timestamp column/field, etc.
 */
export const databaseSemanticAnchors = pgTable("database_semantic_anchors", {
    id: uuid("id").primaryKey().defaultRandom(),
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }),
    integrationId: uuid("integration_id")
        .notNull()
        .references(() => organisationIntegrations.id, { onDelete: "cascade" }),
    databaseType: text("database_type").notNull().$type(),
    anchorsJson: jsonb("anchors_json").notNull().$type(),
    confidenceScoresJson: jsonb("confidence_scores_json")
        .notNull()
        .$type()
        .default({}),
    version: text("version").notNull().default("v1"),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, table => ({
    uniqueCompanyIntegration: uniqueIndex("database_semantic_anchors_company_integration").on(table.companyId, table.integrationId),
    companyIdx: index("database_semantic_anchors_company").on(table.companyId),
    databaseTypeIdx: index("database_semantic_anchors_database_type").on(table.databaseType),
}));
